// extracted by mini-css-extract-plugin
export default {"repoListWrapper":"repoList_repoListWrapper__DVsiP","repoListsSubHeader":"repoList_repoListsSubHeader__mjebL","repoListContent":"repoList_repoListContent__mWWj0"};